import { Controller } from "@hotwired/stimulus";
export default class extends Controller {
  connect() {}

  select_project() {
    Turbo.visit("/projects/" + this.data.get("projectid"));
  }
}
